import styled, { keyframes } from "styled-components";
import { theme } from "../../../styles/theme";
import logoSenne from "../../../images/logo.svg";

/*
 * Loader de rota/auth no DS v2: fundo cream, marca Senne com respiração sutil e
 * uma barra indeterminada em laranja — no lugar do spinner cru sobre gradiente
 * azulado. Respeita prefers-reduced-motion.
 */

const breathe = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50%      { opacity: 0.72; transform: scale(0.985); }
`;

const slide = keyframes`
  0%   { left: -40%; }
  100% { left: 100%; }
`;

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 40px 20px;
  box-sizing: border-box;
  background: ${theme.colors.bg};
`;

const Brand = styled.img`
  height: 56px;
  width: auto;
  object-fit: contain;
  display: block;
  animation: ${breathe} 2.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Track = styled.div`
  position: relative;
  width: 180px;
  height: 4px;
  border-radius: ${theme.radii.pill};
  background: ${theme.colors.gray200};
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -40%;
    width: 40%;
    height: 100%;
    border-radius: ${theme.radii.pill};
    background: ${theme.colors.senneOrange};
    animation: ${slide} 1.15s ${theme.motion.easeOut} infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
      left: 0;
      width: 100%;
      opacity: 0.6;
    }
  }
`;

const LoadingText = styled.p`
  margin: 0;
  font-family: ${theme.typography.fontBody};
  font-size: ${theme.typography.fs.body};
  color: ${theme.colors.fg2};
`;

interface RouteLoaderProps {
  message?: string;
  /** Compat: o loader v2 já mostra a marca sempre; prop mantida p/ não quebrar chamadas. */
  showLogo?: boolean;
}

export function RouteLoader({ message = "Carregando..." }: RouteLoaderProps) {
  return (
    <Container role="status" aria-live="polite" aria-busy="true">
      <Brand src={logoSenne} alt="Senne Liquor" />
      <Track aria-hidden="true" />
      {message && <LoadingText>{message}</LoadingText>}
    </Container>
  );
}

export default RouteLoader;
